const GG = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
const pad = (n) => String(n).padStart(2, "0");

const UFFICI_ROLES = ["Uffici Direzione", "Uffici Utenza", "Addetto pulizie", "Responsabile amministrativo", "Direttore"];
const UFF_STD = { "09.00-17.00": { background: "#1E3A8A", color: "#fff" }, "09.00-13.00": { background: "#87CEEB", color: "#1B3A5B" }, "13.00-17.00": { background: "#4169E1", color: "#fff" } };
const UFF_OTHER = new Set(["07.00-11.00", "08.00-14.00", "07.00-15.00"]);
const norm = (v) => ((v || "").match(/\d{1,2}[.:]\d{2}/g) || []).map((t) => t.replace(":", ".").padStart(5, "0")).join("-");

export function cellStyle(v, roles = []) {
  const s = (v || "").trim().toLowerCase();
  if (!s) return {};
  if (/^permess/.test(s) && !/\d{1,2}[.:]\d{2}/.test(s)) return { background: "#9CA3AF", color: "#111827" };
  const uffici = roles.some((r) => UFFICI_ROLES.includes(r)) && /\d{1,2}[.:]\d{2}/.test(s);
  if (uffici) {
    const n = norm(v);
    if (UFF_STD[n] && !s.includes(",")) return UFF_STD[n];
    if (s.includes(",") || !UFF_OTHER.has(n)) return { background: "#BBF7D0", color: "#14532D" };
  }
  if (s.startsWith("riposo")) return { background: "#F5F5DC", color: "#334155" };
  if (s.startsWith("ferie")) return { background: "#D0D0D0", color: "#334155" };
  if (s.startsWith("festa")) return { background: "#C0C0C0", color: "#334155" };
  if (s.includes("malatt")) return { background: "#DC2626", color: "#fff" };
  const tag = /\bT\b/.test(v) ? "T" : /\bM\b/.test(v) ? "M" : null;
  const torre = tag ? tag === "T" : roles.some((r) => /torre/i.test(r));
  const nostromo = !tag && roles.some((r) => /nostromo/i.test(r));
  if (nostromo) return { background: "#374151", color: "#fff" };
  if (s.startsWith("15")) return torre ? { background: "#908435", color: "#fff" } : { background: "#007FFF", color: "#fff" };
  if (s.startsWith("10")) return { background: "#FBCEB1", color: "#1B3A5B" };
  return torre ? { background: "#BEBD7F", color: "#1B3A5B" } : { background: "#ABCDEF", color: "#1B3A5B" };
}

export function buildCols(d) {
  if (d.columns?.length) return d.columns.map((c) => ({ uid: c.uid, label: c.label, kind: c.kind || "all", roles: c.roles || [] }));
  const m = new Map();
  [...(d.forced_cols || []), ...(d.shifts || [])].forEach((s) => { if (!m.has(s.user_id)) m.set(s.user_id, { uid: s.user_id, label: s.cognome || s.user_name, kind: "all", roles: s.mansioni || [] }); });
  return [...m.values()];
}

const TH = "sticky top-0 z-10 p-2 whitespace-nowrap font-semibold text-white bg-[#1B3A5B] border-b border-white/10";

const LEGEND = [
  ["07.00-15.00", "Mattina banchina / manutentori", {}],
  ["15.00-23.00", "Pomeriggio banchina", {}],
  ["10.00-18.00", "Turno centrale", {}],
  ["07.00-15.00 T", "Mattina torre di controllo", {}],
  ["15.00-23.00 T", "Pomeriggio torre di controllo", {}],
  ["07.00", "Nostromo", { roles: ["Nostromo"] }],
  ["Riposo", "Riposo", {}],
  ["Ferie", "Ferie", {}],
  ["Permesso", "Permesso (intera giornata)", {}],
  ["Festa goduta", "Festa goduta", {}],
  ["Malattia", "Malattia", {}],
  ["09.00-17.00", "Uffici 09-17", { roles: ["Uffici Direzione"] }],
  ["09.00-13.00", "Uffici 09-13", { roles: ["Uffici Direzione"] }],
  ["13.00-17.00", "Uffici 13-17", { roles: ["Uffici Direzione"] }],
  ["9.00-12.00, 14.00-17.00", "Uffici orario ridotto per permesso", { roles: ["Uffici Direzione"] }],
];

export const ShiftLegend = () => (
  <div className="px-4 py-4 border-t bg-white" data-testid="shifts-legend">
    <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3">Legenda</p>
    <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-600">
      {LEGEND.map(([v, l, o]) => (
        <span key={l} className="flex items-center gap-2" data-testid={`legend-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <span className="w-6 h-4 rounded" style={cellStyle(v, o.roles)} />{l}
        </span>))}
      <span className="flex items-center gap-2"><span className="w-6 h-4 rounded bg-[#EDEBFB]" />Rep 1 / Rep 2: reperibili del giorno</span>
      <span className="flex items-center gap-2"><span className="w-6 h-4 rounded bg-[#FEE2E2]" />Domenica</span>
    </div>
    <p className="text-xs text-slate-600 mt-3" data-testid="legend-letters"><b className="text-[var(--navy)]">T</b> dopo l'orario: turno svolto in torre di controllo, colori della torre · <b className="text-[var(--navy)]">M</b> dopo l'orario: turno svolto in banchina, colori degli addetti di banchina.</p>
  </div>
);

export function ShiftGrid({ d, mese, anno, onCell, onRep, testid = "shifts-table" }) {
  const cols = buildCols(d);
  const reps = d.reps && Object.keys(d.reps).length ? d.reps : null;
  const days = Array.from({ length: new Date(anno, mese, 0).getDate() }, (_, i) => i + 1);
  const map = new Map((d.shifts || []).map((s) => [`${s.user_id}|${s.data}`, s.orario || ""]));
  return (
    <>
    <div className="overflow-auto max-h-[70vh]" data-testid={testid}>
      <table className="text-xs border-separate border-spacing-0">
        <thead><tr>
          <th className={`${TH} left-0 z-20 text-left`}>Giorno</th>
          {reps && <><th className={TH}>Rep 1</th><th className={TH}>Rep 2</th></>}
          {cols.map((c) => <th key={c.uid + c.kind} className={TH}>{c.label}</th>)}
        </tr></thead>
        <tbody>{days.map((day) => {
          const data = `${anno}-${pad(mese)}-${pad(day)}`;
          const wd = new Date(anno, mese - 1, day).getDay();
          return (
            <tr key={day}>
              <td className={`sticky left-0 z-10 p-2 border-b border-white whitespace-nowrap font-semibold ${wd === 0 ? "bg-[#FEE2E2] text-red-700" : "bg-[#EEF2F6] text-[var(--navy)]"}`}>{day} {GG[wd]}</td>
              {reps && ["rep1", "rep2"].map((k) => <td key={k} className="p-1 border-b border-white whitespace-nowrap text-center bg-[#EDEBFB] text-[var(--navy)] font-medium" data-testid={`shift-${k}-${day}`}>
                {onRep ? <select value={reps[day]?.[k] || ""} onChange={(e) => onRep(day, k, e.target.value)} className="bg-transparent rounded px-1 py-1 text-xs font-medium cursor-pointer hover:bg-white/70 focus:outline-none focus:ring-2 focus:ring-[var(--teal)] max-w-[110px]" data-testid={`rep-select-${k}-${day}`}>
                  <option value="">—</option>
                  {[...new Set([...cols.map((c) => c.label), reps[day]?.[k]].filter(Boolean))].map((n) => <option key={n} value={n}>{n}</option>)}
                </select> : reps[day]?.[k] || ""}
              </td>)}
              {cols.map((c) => {
                const v = map.get(`${c.uid}|${data}`) || "";
                const body = <span className="block w-full min-w-[86px] rounded-md px-2 py-1.5 text-center font-medium" style={cellStyle(v, c.roles)}>{v || "·"}</span>;
                return (
                  <td key={c.uid + c.kind} className="p-0.5 border-b border-white" data-testid={`shift-cell-${c.uid}-${day}`}>
                    {onCell ? <button className="w-full hover:ring-2 hover:ring-[var(--teal)] rounded-md transition-shadow" onClick={() => onCell({ uid: c.uid, kind: c.kind, data, label: c.label, orario: v })}>{body}</button> : body}
                  </td>);
              })}
            </tr>);
        })}</tbody>
      </table>
    </div>
    <ShiftLegend />
    </>
  );
}
